<template>
  <md-card>
    <md-card-content>
      <h4>Condition</h4>
      <div class="md-layout">
        <div
          class="md-layout-item md-size-100 occupancy"
          style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap"
        >
          <span class="title">Hotel occupancy</span>
          <ValidationProvider name="Hotel occupancy" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
            <div class="occupancy">
              <md-radio v-model="condition.total_hotel_occupancy_format" value="PERCENTAGE">% occ</md-radio>
              <md-radio v-model="condition.total_hotel_occupancy_format" value="ABSOLUTE">rooms</md-radio>
              <span class="radio-error" :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <span>between</span>
          <ValidationProvider name="min" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
            <md-field
              style="display: inline-flex"
              class="md-field md-layout-item md-size-20 md-theme-default"
              :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]"
            >
              <label>min</label>
              <md-input v-model="condition.total_hotel_occupancy_sold_from" />
              <span class="radio-error" :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
            </md-field>
          </ValidationProvider>
          <span>and</span>
          <ValidationProvider name="max" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
            <md-field
              style="display: inline-flex"
              class="md-field md-layout-item md-size-20 md-theme-default"
              :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]"
            >
              <label>max</label>
              <md-input v-model="condition.total_hotel_occupancy_sold_to" />
              <span class="radio-error" :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
            </md-field>
          </ValidationProvider>
        </div>
      </div>
      <div class="md-layout">
        <div
          v-if="showRoomOccupancy"
          class="md-layout-item md-size-100 occupancy"
          style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap"
        >
          <span class="title">Room occupancy</span>
          <ValidationProvider name="Room occupancy" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
            <div class="occupancy">
              <md-radio v-model="condition.total_room_occupancy_format" value="PERCENTAGE">% occ</md-radio>
              <md-radio v-model="condition.total_room_occupancy_format" value="ABSOLUTE">rooms</md-radio>
              <span class="radio-error" :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <span>between</span>
          <ValidationProvider name="min" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
            <md-field
              style="display: inline-flex"
              class="md-field md-layout-item md-size-20 md-theme-default"
              :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]"
            >
              <label>min</label>
              <md-input type="number" v-model="condition.total_room_occupancy_sold_from" />
              <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
            </md-field>
          </ValidationProvider>
          <span>and</span>
          <ValidationProvider name="max" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
            <md-field
              style="display: inline-flex"
              class="md-field md-layout-item md-size-20 md-theme-default"
              :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]"
            >
              <label>max</label>
              <md-input type="number" v-model="condition.total_room_occupancy_sold_to" />
              <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
            </md-field>
          </ValidationProvider>
        </div>
      </div>

      <div class="md-layout-item">
        <md-checkbox v-model="condition.online">online pick up</md-checkbox>
      </div>
      <div class="md-layout">
        <h4>Actions</h4>
        <div
          class="md-layout-item md-size-100"
          style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;"
          v-for="(action, index) in condition.actions"
          :key="'action_' + index"
        >
          <div class="vertical-middle">
            <md-field>
              <label>Increment</label>
              <md-input v-model="action.delta"></md-input>
            </md-field>
          </div>
          <div class="vertical-middle">
            <md-radio v-model="action.percent" :value="false">{{ currency }}</md-radio>
            <md-radio v-model="action.percent" :value="true">%</md-radio>
            for every
          </div>
          <div class="vertical-middle">
            <md-field>
              <md-input v-model="action.foreach_quantity_sold"></md-input>
            </md-field>
          </div>
          rn pick up
          <div class="vertical-middle">
            <channel-select v-model="action.online_channel_ids" :online="true" multiple></channel-select>
          </div>
          <md-button
            title="Add action"
            @click="addActionTo(condition)"
            v-if="index == condition.actions.length - 1"
            class="md-white md-just-icon"
            ><md-icon>add</md-icon></md-button
          >
        </div>
      </div>

      <md-button class="md-icon-button md-white" @click="$emit('delete')">
        <md-icon>delete</md-icon>
      </md-button>
    </md-card-content>
  </md-card>
</template>

<script>
import Vue from 'vue'
import ChannelSelect from '../Inputs/ChannelSelect.vue'
import { Action } from './models'
import Currency from '@/utils/Currency'

let currency

export default {
  name: 'PricingRuleCard',
  components: {
    ChannelSelect,
  },
  data() {
    return {
      roomTypeSelect: [],
    }
  },
  props: {
    condition: Object,
    room_type_ids: Array,
  },
  methods: {
    addActionTo(condition) {
      condition.actions.push(new Action())
    },
  },
  computed: {
    showRoomOccupancy: function() {
      return !!this.room_type_ids && this.room_type_ids.length > 0 && this.room_type_ids.length < this.roomTypeSelect.length
    },
  },
  created() {
    if (!this.condition.actions) {
      Vue.set(this.condition, 'actions', [])
      this.addActionTo(this.condition)
    }
    this.roomTypeSelect = this.$store.getters.get('RoomTypeSelect')

    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'set' && mutation.payload.name === 'RoomTypeSelect') {
        this.roomTypeSelect = mutation.payload.value
      }
    })

    this.currency = Currency[sessionStorage.getItem('currency')]
  },

  beforeDestroy() {
    this.unsubscribe()
  },
}
</script>

<style lang="scss">
.occupancy {
  .title {
    width: 110px;
  }
}

.occupancy {
  position: relative;
  display: inline-flex;

  .radio-error {
    height: 20px;
    position: absolute;
    bottom: -22px;
    color: #ff1744;
    font-size: 12px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
}
</style>
